import classNames from 'classnames'
import React from 'react'
import ReactGA from 'react-ga'
import { Link } from 'react-router-dom'
import ym from 'react-yandex-metrika'

import ViewsIcon from '../icons/ViewsIcon'
import CollectionVideo from '../UI/CollectionVideo/CollectionVideo'
import style from './NewCollectionBanner.module.scss'
import { NewCollectionBannerTopTypes } from './NewCollectionBanner.types'

function NewCollectionBannerTop(props: NewCollectionBannerTopTypes) {
  const {
    title,
    lead,
    buttonContent = 'Показать вcю подборку',
    img,
    video,
    id,
    views = null,
    classMod,
    clickHandler,
    link = `/collections/${id}`,
  } = props

  const handleAnalyticArticleMain = () => {
    if (clickHandler) {
      clickHandler()

      return
    }

    ReactGA.ga('send', 'event', 'main', 'collection click', title)

    ym('reachGoal', 'collection click', {
      'main collection click': `Подборка ${id}`,
    })
  }

  const bannerClass = classNames(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    style.NewCollectionBanner,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    classMod && style[classMod]
  )

  return (
    <div className={bannerClass}>
      <div className={style.NewCollectionBanner__head}>
        {views && (
          <div className={style.NewCollectionBanner__views}>
            <ViewsIcon /> {views}
          </div>
        )}
        <div className={style.NewCollectionBanner__row}>
          <div>
            {video ? (
              <CollectionVideo props={video} />
            ) : (
              <img src={img} alt='Картинка подборки' />
            )}
          </div>
          <div>
            <h2>{title}</h2>
            <p>{lead}</p>
            <div className={style.NewCollectionBanner__btn}>
              <Link
                to={link}
                className='btn btn--white'
                onClick={handleAnalyticArticleMain}
              >
                {buttonContent}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewCollectionBannerTop
